import { mixed } from 'yup'
import type { CSSProperties } from 'react'

// html element style attribute property
export const styleSchema = mixed<CSSProperties>()
